import { isSuperUser } from "@saleor/auth/misc";
import { User, User_userPermissions } from "@saleor/fragments/types/User";
import { PermissionEnum } from "@saleor/types/globalTypes";

import { TabValuesEnum } from "./filters";

interface GetDropOffTabs {
  label: string;
  route: TabValuesEnum;
  value: number;
  showTab: boolean;
}

export const getDropOffTabs = (): GetDropOffTabs[] => {
  const tabs = [
    { label: "Templates", route: TabValuesEnum.TEMPLATES, showTab: true },
    {
      label: "Task Area Management",
      route: TabValuesEnum.TASK_AREA_MANAGEMENT,
      showTab: false
    },
    {
      label: "Runner Assignment",
      route: TabValuesEnum.RUNNER_ASSIGNMENT,
      showTab: true
    }
  ];
  return tabs.map((tab, index) => ({ ...tab, value: index }));
};

export const userHasPermission = (
  userPermissions: User_userPermissions[],
  permissionGiven: PermissionEnum
) => !!userPermissions?.find(p => p.code === permissionGiven);

export const userCanManageHomeLocations = (user: User) =>
  isSuperUser(user) ||
  userHasPermission(
    user?.userPermissions,
    PermissionEnum.MANAGE_HOME_LOCATIONS
  );

export const userCanManageTaskAreas = (user: User) =>
  isSuperUser(user) ||
  userHasPermission(user?.userPermissions, PermissionEnum.MANAGE_TASK_AREAS);

export enum TemplateAction {
  CREATE = "CREATE",
  EDIT = "EDIT",
  VIEW = "VIEW"
}
